<template>
    <kiosk-layout formContainer>
        <form-container>
            <step-form-heading :icon="faArrowsDownToPeople">
                New Group Import

                <template v-slot:description> Create and update Voxie groups in bulk. </template>
            </step-form-heading>

            <form-wrapper
                :sections="[
                    { id: 'template', label: 'Template' },
                    { id: 'upload', label: 'Upload' },
                ]"
            >
                <group-import-new-template id="template"></group-import-new-template>
                <div id="upload">
                    <group-import-new-upload @selected="selectedFile"></group-import-new-upload>
                </div>

                <vx-sticky-footer>
                    <vx-button
                        :href="`/kiosk/teams/${props.teamId}/groups/imports`"
                        data-test="cancel-button"
                        class="w-20"
                        size="lg"
                        color="muted"
                    >
                        Cancel
                    </vx-button>
                    <vx-button
                        @click="submit()"
                        data-test="submit-button"
                        :disabled="!file"
                        class="grow"
                        size="lg"
                        color="primary"
                        :loading="submitting"
                    >
                        Import
                    </vx-button>
                </vx-sticky-footer>
            </form-wrapper>
        </form-container>
    </kiosk-layout>
</template>

<script lang="ts" setup>
import { VxButton, VxStickyFooter } from '@voxie/frontend-components';
import { faArrowsDownToPeople } from '@fortawesome/pro-solid-svg-icons';
import FormWrapper from '~/components/general/FormWrapper.vue';
import FormContainer from '~/components/general/FormContainer.vue';
import StepFormHeading from '~/components/general/StepFormHeading.vue';
import GroupImportNewTemplate from '~/components/group-import/new/GroupImportNewTemplate.vue';
import GroupImportNewUpload from '~/components/group-import/new/GroupImportNewUpload.vue';
import KioskLayout from '~/components/kiosk/KioskLayout.vue';
import { useGroupImportSubmit } from '~/components/group-import/new/useGroupImportSubmit';
import { stringifyQueryString } from '~/utils/string';

const props = defineProps<{
    teamId: number;
}>();

const { file, submitting, selectedFile, submit } = useGroupImportSubmit(
    props.teamId,
    (data) => `/kiosk/teams/${props.teamId}/groups/imports?${stringifyQueryString({ ...data, success: 1 })}`
);
</script>
